import { Navigate, useLocation, NavigateProps } from 'react-router-dom';

export function RedirectWithQueryParams({ to, ...props }: NavigateProps) {
  const location = useLocation();
  const search = location.search;

  return <Navigate to={`${to}${search}`} {...props} />;
}
